<template>
  <e-layout-publico titulo="Boleto da pré-matrícula">
    <v-alert v-if="recemCriada" type="success" outlined dense> Pré-matrícula registrada. </v-alert>

    <template v-if="boleto">
      <p>Baixe o boleto ou copie a linha digitável para pagar.</p>
      <v-btn v-if="boleto.pdf_base64" block color="primary" class="mb-4" @click="baixarPdf">
        <v-icon left>fa fa-download</v-icon>
        Baixar boleto (PDF)
      </v-btn>
      <v-alert v-else type="warning" outlined dense>
        O PDF do boleto não está disponível agora. O pagamento pode ser feito pela linha digitável
        abaixo.
      </v-alert>

      <e-label>Linha digitável</e-label>
      <v-text-field
        :value="boleto.linha_digitavel"
        readonly
        append-icon="fa fa-copy"
        aria-label="Linha digitável do boleto"
        dense
        solo
        @click:append="copiarLinhaDigitavel"
      />
    </template>

    <v-alert v-else-if="mensagem" type="warning" outlined role="alert">{{ mensagem }}</v-alert>

    <v-alert type="info" outlined>
      Para voltar a este boleto depois, basta informar o <strong>CPF</strong> e a
      <strong>data de nascimento do aluno</strong> na tela de pré-matrícula.
    </v-alert>

    <v-btn block text :to="{ name: 'preMatricula.entrada' }">Ir para a tela de pré-matrícula</v-btn>
  </e-layout-publico>
</template>

<script>
import ELayoutPublico from "@/components/PreMatriculas/ELayoutPublico.vue";

/**
 * O boleto chega por parâmetro de rota, vindo da gravação ou da consulta por CPF. Não existe
 * endereço próprio do boleto: recarregar a página perde o boleto, e a volta é pela tela de entrada.
 */
export default {
  name: "PreMatriculaBoletoPage",
  components: { ELayoutPublico },
  data() {
    const { boleto, mensagem, recemCriada } = this.$route.params;
    return { boleto: boleto || null, mensagem: mensagem || null, recemCriada: !!recemCriada };
  },
  methods: {
    baixarPdf() {
      const bytes = Uint8Array.from(atob(this.boleto.pdf_base64), (c) => c.charCodeAt(0));
      const url = URL.createObjectURL(new Blob([bytes], { type: "application/pdf" }));
      const link = document.createElement("a");
      link.href = url;
      link.download = "boleto-pre-matricula.pdf";
      link.click();
      // Revogar na hora cancela o download em alguns navegadores.
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    },
    async copiarLinhaDigitavel() {
      try {
        await navigator.clipboard.writeText(this.boleto.linha_digitavel);
        this.$toast.success("Linha digitável copiada.");
      } catch (error) {
        this.$toast.warn("Não foi possível copiar. Selecione o texto e copie manualmente.");
      }
    },
  },
};
</script>
